import React from 'react';

//import Style from '../style.module.css';
import '../style.css';
import { AircraftGeneralContainer } from './AircraftGeneral.style';

import AircraftGallery from '@components/AircraftGallery';
import Amenities from '@components/Amenities';
import Certifications from '@components/Certifications';
import AircraftDetails from '../AircraftDetails';

const AircraftGeneral = ({
  aircraftGallery,
  aircraftDescription,
  aircraftCertifications,
  aircraftAmenities,
  isModal,
  showAmenities,
}) => {
  return (
    <AircraftGeneralContainer className="aircraft">
      <AircraftGallery
        flightPage={true}
        images={aircraftGallery}
        isModal={isModal}
      />
      <div
        className={
          isModal
            ? ['aircraftMeta', 'aircraftMetaModal'].join(' ')
            : 'aircraftMeta'
        }
      >
        <AircraftDetails
          aircraftDescription={aircraftDescription.aircraftDescription}
          avaliation={aircraftDescription.avaliation}
        />
        {aircraftCertifications[0] && (
          <Certifications
            certifications={aircraftCertifications}
            governmentOnly={true}
          />
        )}
        {aircraftAmenities[0] && showAmenities ? (
          <>
            <Amenities
              showTitle={true}
              amenities={aircraftAmenities}
              limitToShow={99}
              greyScale={false}
              theme={'green'}
            />
          </>
        ) : (
          <div />
        )}
      </div>
    </AircraftGeneralContainer>
  );
};

export default AircraftGeneral;
